import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Constants } from '../config/constant';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(
    private http: HttpClient,
    private _const: Constants,
    private snackbar: MatSnackBar
  ) { }

  private extractData(res: any) {
    return res.body;
  }

  private configData(res: any) {
    if (res.body.status) {
      sessionStorage.setItem('clients', JSON.stringify(res.body.data.clients));
      sessionStorage.setItem(
        'chatbotTypes',
        JSON.stringify(res.body.data.chatbotTypes)
      );
      return res.body.status;
    }
  }

  private handleErrorObservable = (error: any) => {
    if (error.error.message) {
      this.snackbar.open(error.error.message, undefined, {
        duration: 5000,
        panelClass: 'failure',
      });
    } else if (error.error.detail) {
      this.snackbar.open(error.error.detail, undefined, {
        duration: 5000,
        panelClass: 'failure',
      });
    } else {
      this.snackbar.open(
        'Oops! Something went wrong, Please Try again later...',
        undefined,
        {
          duration: 5000,
          panelClass: 'failure',
        }
      );
    }
    return throwError(error);
  };

  logs(param) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/activity/logs`, param, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  chatbot(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/chatbotjson/excelV2`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  microLearning(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/microlearningjson/excel`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  mindBodySoul(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/mindbodysouljson/excel`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  factoid(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/factoidjson/excel`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  osh(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/osh/excelV2`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  gamesExcel(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/gamejson/excelV2`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  config() {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/config`, null, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.configData));
  }

  menu() {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/menu`, null, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  shipActivity(param) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/activity/ship`, param, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  userActivity(param) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/activity/user`, param, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  clientOnboardingOptions() {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .get(`${this._const.API}/clientonboarding`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  clientOnboardingUpload(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/clientonboarding/upload`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  clientOnboardingCreate(param) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/clientonboarding/create`, param, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  faq(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/faq/html`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  reports(param) {
    let url: string = location.pathname.split('/').pop();
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/${url}`, param, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  zoho(formData: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/zoholinks/excel`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  summaryReport(data: { comments: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/synopsis`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  getReportTypes() {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .get(`${this._const.API}/reports/clientengagementreport`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  clientEngagementReport(data: {
    client: string;
    reportType: string;
    comments: string;
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/clientengagementreport`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  clientCapacityReport(data: { client: string; comments: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/clientcapacitydata`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  statisticsReport(data: { comments: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/clientstatisticsreport`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  internalAdminPanel(data: { startDate: Date; endDate: Date; comments: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/internaladminpaneldatav02`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  psychologistReport(data: { comments: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/psychologistreportv01`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  nutritionistReport(data: { comments: string }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/reports/nutritionistreportv01`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  monthlyReport(data: {
    client: string; startDate: Date; endDate: Date; comments: string
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    debugger
    return this.http
      .post(`${this._const.API}/reports/monthlyreport`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  quarterlyReport(data: {
    client: string; type: string; fleet: string; startDate: Date; endDate: Date; comments: string
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    debugger
    return this.http
      .post(`${this._const.API}/reports/sharkquarterlyreportv03`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  annuallyReport(data: {
    client: string; type: string; fleet: string; startDate: Date; endDate: Date; version: string; comments: string
  }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    debugger
    return this.http
      .post(`${this._const.API}/periodicreports/sharkannuallyreportv03`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  reportsFeedback(data: { id: string; feedback: string; rating: number }) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .put(`${this._const.API}/reports/feedback`, data, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  documentarchivedetails(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/documentarchive/details`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }
  documentarchivereports(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/documentarchive/reports`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }
  documentarchivecollaterals(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/documentarchive/collaterals`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  documentarchivecreate(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/documentarchive/create`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  documentarchivedelete(jsonPayload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
        'Content-Type': 'application/json',
      }),
    };

    return this.http.put(`${this._const.API}/documentarchive/delete`, jsonPayload, {
      observe: 'response',
      headers: httpOptions.headers,
    }).pipe(
      map(this.extractData),
      catchError(this.handleErrorObservable)
    );
  }

  videoLibraryUpload(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/videolibrary/upload`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  videoLibraryStatus(jobId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .get(`${this._const.API}/videolibrary/upload/status/${jobId}`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  pemeContentIngest(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/pemecontent/ingest`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  pemeContentStatus(uuid: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .get(`${this._const.API}/pemecontent/status/${uuid}`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  pemeCheckinsUpload(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/pemecheckins/upload`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  pemeDailyTaskUpload(formData: FormData) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .post(`${this._const.API}/pemedailytask/ingest`, formData, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  pemeDailyTaskStatus(jobId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .get(`${this._const.API}/pemedailytask/status/${jobId}`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

  pemeCheckinsStatus(jobId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${sessionStorage.getItem('access')}`,
      }),
    };
    return this.http
      .get(`${this._const.API}/pemecheckins/status/${jobId}`, {
        observe: 'response',
        headers: httpOptions.headers,
      })
      .pipe(catchError(this.handleErrorObservable), map(this.extractData));
  }

}
